import { Badge } from "@/components/ui/badge"
import { Label } from "@/components/ui/label"

export function DriverInfo({ markerData }: { markerData: any }) {
    const availableDriver = markerData?.drivers?.find((driver: any) => driver.active === true)

    return (
        <div className="mt-2 mb-4">
            <Label className="text-xs mb-2 ml-1 block">Driver assigned</Label>

            {markerData && Object.keys(markerData).length > 0 && markerData.drivers?.length > 0 ? (
                availableDriver ? (
                    <div className="flex items-center justify-between">
                        <p className="text-sm font-semibold ml-1">{availableDriver.name}</p>
                        <Badge variant="default" className="bg-orange-500 text-white font-bold capitalize">
                            {availableDriver.status}
                        </Badge>
                    </div>
                ) : (
                    <p className="text-xs text-muted-foreground ml-1">
                        No active driver for vehicle <span className="font-semibold">{markerData.nickname}</span>
                    </p>
                )
            ) : (
                <p className="text-xs text-muted-foreground ml-1">No driver selected</p>
            )}
        </div>
    )
}